import { ref, onMounted } from "vue";
import { f7 } from "framework7-vue";
import { openAdaptiveModal } from "./useAdaptiveModal.js";
import { Capacitor } from "@capacitor/core";
import {
  CapacitorBarcodeScanner,
  CapacitorBarcodeScannerAndroidScanningLibrary,
  CapacitorBarcodeScannerCameraDirection,
  CapacitorBarcodeScannerScanOrientation,
  CapacitorBarcodeScannerTypeHint,
} from "@capacitor/barcode-scanner";
import i18n from "../i18n.js";

export function useScanQRCode({ onExternalLink } = {}) {
  const t = i18n.global.t;
  const techPermission = ref(null);
  const resultQR = ref("");

  function checkPermission(permissionName) {
    try {
      navigator.permissions
        .query(Object.assign({ name: permissionName }))
        .then((permission) => {
          console.log(permission);
          techPermission.value = {
            name: permissionName,
            state: permission.state,
          };
          console.log(techPermission.value);
          if (permission.state == "granted") {
          } else if (permission.state == "prompt") {
           switch (permissionName) {
  case "camera":
    // Modern API returns a Promise and doesn't require 3 arguments
    navigator.mediaDevices.getUserMedia({ video: true, audio: true })
      .catch(err => console.error("Camera access denied:", err));
    break;
  case "microphone":
    navigator.mediaDevices.getUserMedia({ audio: true })
      .catch(err => console.error("Microphone access denied:", err));
    break;
  case "geolocation":
    navigator.geolocation.getCurrentPosition(() => {}, (err) => console.error(err));
    break;
  case "notifications":
    Notification.requestPermission();
    break;
}
          } else if (permission.state == "denied") {
          }
          permission.addEventListener("change", () => {
            techPermission.value = {
              name: permissionName,
              state: permission.state,
            };
          });
        });
    } catch (e) {}
  }

  function requestCamera() {
    navigator.getUserMedia({ video: true });
  }

  async function startBrowserScanner() {
    console.log(techPermission.value);
    if (
      !(
        techPermission.value &&
        techPermission.value.name === "camera" &&
        techPermission.value.state === "granted"
      )
    ) {
      checkPermission("camera");
    }
    openAdaptiveModal(".ScanQrCodeNoCordova");
  }

  function scanQRCodeNoCordova() {
    openAdaptiveModal(".ScanQrCodeNoCordova");
  }

  async function scanQRCode() {
    checkPermission("camera");
    if (Capacitor.isNativePlatform()) {
      try {
        const result = await CapacitorBarcodeScanner.scanBarcode({
          hint: CapacitorBarcodeScannerTypeHint.ALL,
          scanInstructions: t("common.scannerPrompt"),
          scanButton: true,
          scanText: t("common.scan"),
          cameraDirection: CapacitorBarcodeScannerCameraDirection.BACK,
          scanOrientation: CapacitorBarcodeScannerScanOrientation.ADAPTIVE,
          android: {
            scanningLibrary:
              CapacitorBarcodeScannerAndroidScanningLibrary.ZXING,
          },
          web: { showCameraSelection: true, scannerFPS: 30 },
        });
        console.log("scanResult", result.ScanResult);
        resultQR.value = result.ScanResult;
        checkQrCode(result.ScanResult);
      } catch (error) {
        let errorMessage;
        if (error instanceof Error) {
          errorMessage = error.message;
          console.log("Error: " + error.message);
        } else {
          errorMessage = "Error: Unknown error";
          console.log("Error: Unknown error");
        }
        resultQR.value = `${t("common.failedScanning")} ${errorMessage}`;
        openAdaptiveModal(".notAvocashQRCODE");
      }
    } else {
      scanQRCodeNoCordova();
    }
  }

  function checkQrCode(code) {
    if (code.match(/href="(.*?)"/)) {
      try {
        const url = new URL(code);
        if (onExternalLink) {
          onExternalLink(url);
        }
      } catch (error) {
        console.log(error);
      }
      resultQR.value = code;
      openAdaptiveModal(".notAvocashQRCODE");
      return;
    }
    resultQR.value = code;
    openAdaptiveModal(".notAvocashQRCODE");
  }

  onMounted(() => {
    navigator.getUserMedia =
      navigator.getUserMedia ||
      navigator.webkitGetUserMedia ||
      navigator.mozGetUserMedia ||
      navigator.msGetUserMedia;
  });

  return {
    techPermission,
    resultQR,
    checkPermission,
    requestCamera,
    startBrowserScanner,
    scanQRCodeNoCordova,
    scanQRCode,
    checkQrCode,
  };
}
